import config from 'config';

export const getInvoiceDownloadLink = (orderId, transactionId) =>
  `${config.api.baseUrlDownload || config.api.baseUrl}${
    config.api.url
  }/orders/${orderId}/transactions/${transactionId}/invoice`;

export default getInvoiceDownloadLink;
